import React, { useState } from 'react';
import { AppBar, Toolbar, IconButton, Box, Button, Drawer, List, ListItem, ListItemButton, ListItemText, useScrollTrigger } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { Link as RouterLink } from 'react-router-dom';
import Logo from '../assets/images/logo.png';

function ElevationScroll(props) {
  const { children } = props;
  const trigger = useScrollTrigger({ disableHysteresis: true, threshold: 64 });
  return React.cloneElement(children, {
    elevation: trigger ? 4 : 0,
    color: trigger ? 'default' : 'default'
  });
}

const nav = [
  { label: 'Home', path: '/' },
  { label: 'About', path: '/about' },
  { label: 'Services', path: '/services' },
  { label: 'Blog', path: '/blog' },
  { label: 'Contact', path: '/contact' },
  { label: 'Book Now', path: '/book' }
];

export default function Header() {
  const [open, setOpen] = useState(false);
  return (
    <ElevationScroll>
      <AppBar position="sticky" sx={{ bgcolor: 'background.paper' }}>
        <Toolbar sx={{ gap: 2 }}>
          <Box component={RouterLink} to="/" sx={{ display:'flex', alignItems:'center', textDecoration:'none' }}>
            <Box component="img" src={Logo} alt="Rite HVAC Services" sx={{ height: 70, mr: 2 }} />
          </Box>
          <Box sx={{ flexGrow: 1 }} />
          <Box sx={{ display: { xs: 'none', md: 'flex' }, gap: 1 }}>
            {nav.map((n) => (
              <Button key={n.path} component={RouterLink} to={n.path} variant={n.label === 'Book Now' ? 'contained' : 'text'} color={n.label === 'Book Now' ? 'primary' : 'inherit'}>
                {n.label}
              </Button>
            ))}
          </Box>
          <IconButton sx={{ display: { xs: 'inline-flex', md: 'none' }}} onClick={() => setOpen(true)} aria-label="menu">
            <MenuIcon />
          </IconButton>
          <Drawer anchor="right" open={open} onClose={() => setOpen(false)}>
            <Box sx={{ width: 280 }} role="presentation" onClick={() => setOpen(false)}>
              <List>
                {nav.map((n) => (
                  <ListItem key={n.path} disablePadding>
                    <ListItemButton component={RouterLink} to={n.path}>
                      <ListItemText primary={n.label} />
                    </ListItemButton>
                  </ListItem>
                ))}
              </List>
            </Box>
          </Drawer>
        </Toolbar>
      </AppBar>
    </ElevationScroll>
  );
}
